/* eslint-disable max-len */
import { GLOBALIZATION_BASE_API_URL, GLOBALIZATION_GET_CULTURES_ENDPOINT, GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT } from '../constants/globalizationConstants';
import httpService from './httpService';

const globalizationService = () => {
  const getCultures = async ({
    page, itensPerPage, order, orderAscendent, cultureCode, cultureName,
  }) => {
    const { get } = httpService();
    const params = {
      Page: page, // int
      ItensPerPage: itensPerPage, // int
      Order: order, // int - Pode ser somente: 1, 2, 3, 4
      OrderAscendent: orderAscendent, // boolean
      Code: cultureCode, // string
      Name: cultureName, // string
    };

    const result = await get(GLOBALIZATION_BASE_API_URL + GLOBALIZATION_GET_CULTURES_ENDPOINT, params);
    return result;
  };

  const getTermAndTranslationsByTag = async ({
    systemId, tag, culture, productId, product,
  }) => {
    const { get } = httpService();
    const params = {
      SystemId: systemId, // int
      Tag: tag, // string
      Culture: culture, // string
      ProductId: productId, // int
      Product: product, // string
    };

    const result = await get(GLOBALIZATION_BASE_API_URL + GLOBALIZATION_GET_TERMS_AND_TRANSLATIONS_BY_TAG_ENDPOINT, params);
    return result;
  };

  return {
    getCultures,
    getTermAndTranslationsByTag,
  };
};

export default globalizationService;
